<template>
    <div>
         <section class="about" id="about">

        <div class="about-title">
            <p>What to know about me</p>
        </div>
        <div class="about-container">

            <div class="about-text">

                <p class=" about-me">
                    My name is Niyera Asaph Gosen, I am a full-stack developer.
                     I am curious about new technologies.
                      I am also interested in research as a research assistant. 
                    in the following section you can see some of my projects.
                    
                 </p>
            
            </div>



        </div>

    </section>

    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="css">
    
</style>